import types from './types';

const initialState = {
  loaded: false,
  currentExtent: null,
  mapColumnVisible: true
};

const mapReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.REHYDRATE:
      return {
        ...state,
        currentExtent: action.payload.map
          ? action.payload.map.currentExtent
          : initialState.currentExtent
      };
    case types.SET_EXTENT:
      return {
        ...state,
        currentExtent: action.payload.extent
      };
    case types.MAP_LOADED:
      return {
        ...state,
        loaded: true
      };
    case types.MAP_COLUMN_VISIBLE:
      return {
        ...state,
        mapColumnVisible: action.payload.mapColumnVisible
      };

    default:
      return state;
  }
};

export default mapReducer;



// WEBPACK FOOTER //
// ./src/redux/map/reducers.js